import React from "react";
import AssetInputOrUploadSection from "./AssetInputOrUploadSection";
import { CREATIVE_NAMES, SHAKER_CREATIVE_AD_FIELDS } from "./definitions";
import DropdownSection from "./DropdownSection";
import BaseCreativeControls from "./BaseCreativeControls";

const CREATIVE_TYPE = CREATIVE_NAMES.EXPANDER_CREATIVE;

const FORMAT_OPTIONS = [
    { label: "300x250 to 970x250", value: "banner" },
    { label: "300x250 to 300x600", value: "right_rail" },
];

const DIRECTIONALITY_OPTIONS = [
    { label: "Right-to-Left", value: "rtl" },
    { label: "Left-to-right", value: "ltr" }
]

export default function ExpanderCreative({
    collapsedBanner,
    expandedBanner,
    handleChange,
    impressionTag,
    currentCustomer,
    format = "banner",
    adServingType,
    clickTag,
    dir = 'rtl'
}) {

    return (
        <>
            <BaseCreativeControls
                isClickTagRequired={true}
                adServingType={adServingType}
                changeHandler={handleChange}
                impressionTag={impressionTag}
                creativeType={CREATIVE_TYPE}
                renderClickUrlInput={true}
                clickTag={clickTag}
            >
                <DropdownSection
                    adtype={CREATIVE_TYPE}
                    label="Expander creative format"
                    name={SHAKER_CREATIVE_AD_FIELDS.format}
                    changeHandler={handleChange}
                    value={format}
                    options={FORMAT_OPTIONS}
                />

                {
                    format === 'banner' && (
                        <DropdownSection
                            adtype={CREATIVE_TYPE}
                            label="Animation directionality"
                            name={SHAKER_CREATIVE_AD_FIELDS.dir}
                            changeHandler={handleChange}
                            value={dir}
                            options={DIRECTIONALITY_OPTIONS}
                        />
                    )
                }

                <AssetInputOrUploadSection
                    inputValue={collapsedBanner}
                    inputLabel="Small banner (300x250px)"
                    inputName={SHAKER_CREATIVE_AD_FIELDS.collapsedBanner}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />

                <AssetInputOrUploadSection
                    inputValue={expandedBanner}
                    inputLabel={`Expanded banner (${format === 'banner' ? '970x250' : '300x600'})`}
                    inputName={SHAKER_CREATIVE_AD_FIELDS.expandedBanner}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />
            </BaseCreativeControls>
        </>
    );
}
